import * as firebaseHelpers from '../helpers/Firebase/';
import * as types from './actionTypes';

export function loadDeposits() {
  return async (dispatch, getState) => {
    const organization = await firebaseHelpers.getCurrentUser(false);
    const { accountType } = getState().userReducer;

    if (organization && accountType === 0) {
      firebaseHelpers.watchCollectionChanges(
        `organizations/${organization.uid}/deposits`,
        (deposits = []) => {
          deposits = deposits.sort((a, b) => {
            if (a.date === b.date) {
              return 0;
            } else if (a.date > b.date) {
              return -1;
            } else {
              return 1;
            }
          });
          dispatch({
            type: types.LOAD_DEPOSITS,
            deposits,
          });
        }
      );
    }
  };
}
